import { Box, Image } from '@chakra-ui/react';

import { useChartTheme } from '@revelio/replots';

import barIcon from '../../assets/svg/bar.svg';
import boxIcon from '../../assets/svg/box.svg';
import chordIcon from '../../assets/svg/chord.svg';
import distributionIcon from '../../assets/svg/distribution.svg';
import divergingBarIcon from '../../assets/svg/diverging-bar.svg';
import divergingBarComboIcon from '../../assets/svg/diverging-bar-combo.svg';
import gaugeIcon from '../../assets/svg/gauge.svg';
import groupedBarIcon from '../../assets/svg/grouped-bar.svg';
import lineIcon from '../../assets/svg/line.svg';
import mapIcon from '../../assets/svg/map.svg';
import naIcon from '../../assets/svg/na.svg';
import sankeyIcon from '../../assets/svg/sankey.svg';
import stackedBarIcon from '../../assets/svg/stacked-bar.svg';
import tableIcon from '../../assets/svg/table.svg';
import textIcon from '../../assets/svg/text.svg';
import aiSummaryThemedIcon from '../../assets/svg/themed/ai-summary.svg';
import barThemedIcon from '../../assets/svg/themed/bar.svg';
import boxThemedIcon from '../../assets/svg/themed/box.svg';
import chordThemedIcon from '../../assets/svg/themed/chord.svg';
import distributionThemedIcon from '../../assets/svg/themed/distribution.svg';
import divergingBarThemedIcon from '../../assets/svg/themed/diverging-bar.svg';
import divergingBarComboThemedIcon from '../../assets/svg/themed/diverging-bar-combo.svg';
import gaugeThemedIcon from '../../assets/svg/themed/gauge.svg';
import groupedBarThemedIcon from '../../assets/svg/themed/grouped-bar.svg';
import lineThemedIcon from '../../assets/svg/themed/line.svg';
import mapThemedIcon from '../../assets/svg/themed/map.svg';
import sankeyThemedIcon from '../../assets/svg/themed/sankey.svg';
import stackedBarThemedIcon from '../../assets/svg/themed/stacked-bar.svg';
import tableThemedIcon from '../../assets/svg/themed/table.svg';
import textThemedIcon from '../../assets/svg/themed/text.svg';
import treemapThemedIcon from '../../assets/svg/themed/treemap.svg';
import volumeThemedIcon from '../../assets/svg/themed/volume.svg';
import treemapIcon from '../../assets/svg/treemap.svg';
import volumeIcon from '../../assets/svg/volume.svg';
import type { SelectableChartType } from '../PageConfigProvider/types/chart';

const iconMap: Record<SelectableChartType, string> = {
  bar: barIcon,
  line: lineIcon,
  treemap: treemapIcon,
  'stacked-bar': stackedBarIcon,
  'grouped-bar': groupedBarIcon,
  'diverging-bar': divergingBarIcon,
  'diverging-bar-combo': divergingBarComboIcon,
  sankey: sankeyIcon,
  chord: chordIcon,
  volume: volumeIcon,
  distribution: distributionIcon,
  box: boxIcon,
  map: mapIcon,
  gauge: gaugeIcon,
  table: tableIcon,
  text: textIcon,
  'ai-summary': textIcon,
};

const themedIconMap: Partial<Record<SelectableChartType, string>> = {
  bar: barThemedIcon,
  map: mapThemedIcon,
  'stacked-bar': stackedBarThemedIcon,
  'grouped-bar': groupedBarThemedIcon,
  'diverging-bar': divergingBarThemedIcon,
  'diverging-bar-combo': divergingBarComboThemedIcon,
  treemap: treemapThemedIcon,
  line: lineThemedIcon,
  gauge: gaugeThemedIcon,
  table: tableThemedIcon,
  text: textThemedIcon,
  'ai-summary': aiSummaryThemedIcon,
  sankey: sankeyThemedIcon,
  chord: chordThemedIcon,
  distribution: distributionThemedIcon,
  volume: volumeThemedIcon,
  box: boxThemedIcon,
};

export const ChartIcon = ({ type }: { type: SelectableChartType }) => {
  const { isNewTheme } = useChartTheme();
  const src = (isNewTheme && themedIconMap[type]) || iconMap[type];
  return (
    <Box boxSize="24px">
      <Image src={src} alt={`${type} icon`} boxSize="100%" />
    </Box>
  );
};

export const NonSelectableChartIcon = () => {
  return (
    <Box boxSize="24px">
      <Image src={naIcon} alt="na icon" boxSize="100%" />
    </Box>
  );
};
